import { render, staticRenderFns } from "./ProductExport.vue?vue&type=template&id=63db0c7e&scoped=true&lang=pug&"
import script from "./ProductExport.vue?vue&type=script&lang=js&"
export * from "./ProductExport.vue?vue&type=script&lang=js&"
import style0 from "./ProductExport.vue?vue&type=style&index=0&id=63db0c7e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63db0c7e",
  null
  
)

/* custom blocks */
import block0 from "./ProductExport.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports